import { render, staticRenderFns } from "./piece.vue?vue&type=template&id=5ec1cbc8&scoped=true"
import script from "./piece.vue?vue&type=script&lang=js"
export * from "./piece.vue?vue&type=script&lang=js"
import style0 from "./piece.vue?vue&type=style&index=0&id=5ec1cbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1cbc8",
  null
  
)

export default component.exports